const API = process.env.REACT_APP_API_URL || '';

export async function api(path, { method = 'GET', body } = {}) {
  const res = await fetch(`${API}/api/privacy-program${path}`, {
    method, credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try { data = await res.json(); } catch { data = { success: false, message: 'No answer from the server' }; }
  return data;
}

// File uploads go as form data; the browser sets the boundary itself.
export async function apiUpload(path, formData) {
  const res = await fetch(`${API}/api/privacy-program${path}`, { method: 'POST', credentials: 'include', body: formData });
  let data = null;
  try { data = await res.json(); } catch { data = { success: false, message: 'No answer from the server' }; }
  return data;
}

// A DATE column arrives as 'YYYY-MM-DD…'; read it as a calendar day.
export function fmtDay(d) {
  if (!d) return '';
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(String(d));
  const dt = m ? new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])) : new Date(d);
  return dt.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

export const STATE = {
  draft: { label: 'Waiting for you', cls: 'bg-amber-50 text-amber-800 ring-1 ring-amber-200' },
  confirmed: { label: 'Confirmed', cls: 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-200' },
  rejected: { label: 'Does not exist', cls: 'bg-slate-100 text-slate-500 ring-1 ring-slate-200' },
};

export const SOURCE = {
  document: 'Read from a document',
  registry: 'From a registry record',
  person: 'Said by a person',
  officer: 'Described by the Privacy Officer',
  template: 'Typical for a Medicare Advantage plan',
};

export function Pill({ cfg, children }) {
  return <span className={`inline-flex items-center px-2.5 py-1 rounded-lg text-xs font-semibold whitespace-nowrap ${cfg}`}>{children}</span>;
}

export function Card({ title, action, children, className = '' }) {
  return (
    <div className={`bg-white rounded-2xl border border-slate-200 ${className}`}>
      {(title || action) && (
        <div className="px-5 pt-4 pb-2 flex items-center justify-between gap-3">
          {title && <h3 className="text-[11px] font-bold uppercase tracking-wider text-slate-500">{title}</h3>}
          {action}
        </div>
      )}
      <div className="px-5 pb-5">{children}</div>
    </div>
  );
}

export function Stat({ label, value, note, tone = 'slate' }) {
  const tones = { slate: 'text-slate-900', green: 'text-emerald-700', amber: 'text-amber-700', red: 'text-red-600' };
  return (
    <div className="bg-white rounded-3xl border border-slate-200 shadow-sm p-5">
      <p className="text-[10px] font-semibold text-slate-500 uppercase tracking-wider">{label}</p>
      <p className={`text-3xl font-bold mt-0.5 tabular-nums ${tones[tone] || tones.slate}`}>{value ?? 0}</p>
      {note && <p className="text-xs text-slate-500 mt-1">{note}</p>}
    </div>
  );
}

/** A small ? bubble carrying a plain explanation. Hover or focus to read it. */
export function Tip({ text }) {
  return (
    <span title={text} aria-label={text} tabIndex={0}
      className="cursor-help inline-flex w-3.5 h-3.5 rounded-full bg-slate-200 text-slate-500 text-[9px] font-bold items-center justify-center flex-shrink-0 align-middle normal-case tracking-normal">?</span>
  );
}
